import {
    Alert, AlertIcon, Button, Flex, FormControl, FormErrorMessage,
    FormLabel, HStack, Input, Text, useToast
} from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { BsBoxArrowInDown, BsX } from 'react-icons/bs'
import { patchUpdateQueueStatus, QueueUpdateStatus } from '../../classes/Queue'
import { useLoadingContext } from '../../context/loadingContext'
import { reload, useSelectedItemAlertContext } from '../../context/selectedItemAlertContext'
import { useUserContext } from '../../context/userContext'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'
import { InputDatePicker, SectionForm, SelectEmailTemplate, SelectQueueStatus } from '../shared'
import { DEFAULT_EMAIL_APPOINTMENT, EMAIL_APPOINTMENT } from '../shared/SelectEmailTemplate'

const FooterQueueAdmin = ({ close }) => {

    const { itemData, setItemData } = useSelectedItemAlertContext()
    const defaultValues = {}
    const { control, handleSubmit,watch,setValue, formState: { errors } } = useForm({ defaultValues })
    const { userData } = useUserContext()
    const { onModalClose, onModalOpen } = useLoadingContext()
    const toast = useToast()

    // watch
    const queueStatusWatch = watch("queue_status")?.value
    const startContractDate = watch("contract_start_date")
    const ageContract = watch("contract_age") || 4

    useEffect(()=>{
        const endDate = startContractDate ? new Date(startContractDate) : new Date()
        endDate.setFullYear(endDate.getFullYear() + parseInt(ageContract))
        setValue("contract_end_date",endDate)
    },[startContractDate, ageContract, setValue])

    const onSubmit = async (data) => {
        const submitData = new QueueUpdateStatus(data)
        
        onModalOpen()
        await patchUpdateQueueStatus(itemData.id, submitData.queue_status_id, submitData, userData.token)
            .then(res => {
                toast(toastVal({
                    title: "การบันทึกข้อมูลสำเร็จ",
                    description: `บันทึกข้อมูล เรียบร้อยแล้ว`,
                }))
                setItemData((prev) => reload(prev))
                onModalClose()
                close()
            })
            .catch(error => {
                onModalClose()
                toast(toastVal({ 
                    title: "การบันทึกข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }
    return (
        <Flex w="full" direction="column">
            <Alert status="warning">
                <AlertIcon />
                <Text>เฉพาะเจ้าหน้าที่</Text>
            </Alert>
            <form onSubmit={handleSubmit(onSubmit)}>
                <SectionForm header="แก้ไขสถานะของคิว" >
                    <FormControl isInvalid={errors.queue_status} isRequired>
                        <FormLabel>สถานะคิว</FormLabel>
                        <SelectQueueStatus control={control} isClearable={false} />
                        {errors.queue_status && <FormErrorMessage>กรุณาเลือกสถานะของคิวที่จะเปลี่ยน</FormErrorMessage>}
                    </FormControl>
                </SectionForm>
                <SectionForm header="แจ้งข้อมูลวันนัด" collapse={queueStatusWatch!=='2'}>
                    <HStack w="full" spacing={2}>
                        <FormControl isRequired={queueStatusWatch==='2'}>
                            <FormLabel>วันและเวลานัด</FormLabel>
                            <InputDatePicker control={control} name="appointment_date" required={queueStatusWatch==='2'}/>
                        </FormControl>
                        <FormControl isRequired={queueStatusWatch==='2'}>
                            <FormLabel>สถานที่นัด</FormLabel>
                            <Controller
                                name="appointment_location"
                                control={control}
                                rules={{ required: queueStatusWatch==='2' }}
                                render={({ field }) => <Input placeholder="กรอกสถานที่" {...field} />}
                            />
                        </FormControl>
                    </HStack>
                    <FormControl isInvalid={errors.email_temp} isRequired={queueStatusWatch==='2'}>
                        <FormLabel>เลือกแบบข้อความอีเมล</FormLabel>
                        <SelectEmailTemplate control={control} mode={EMAIL_APPOINTMENT} defaultValue={DEFAULT_EMAIL_APPOINTMENT} required={queueStatusWatch==='2'} />
                        <FormErrorMessage>กรุณาเลือกแบบข้อความอีเมล</FormErrorMessage>
                    </FormControl>
                </SectionForm>
                <SectionForm header="บันทึกข้อมูลสัญญา" collapse={queueStatusWatch!=='3'}>
                    <HStack w="full" spacing={2}>
                        <FormControl isRequired={queueStatusWatch==='3'}>
                            <FormLabel>วันที่ทำสัญญา</FormLabel>
                            <InputDatePicker control={control} name="contract_date" showTimeInput={false} required={queueStatusWatch==='3'} />
                        </FormControl>
                        <FormControl isRequired={queueStatusWatch==='3'}>
                            <FormLabel>สัญญาเลขที่</FormLabel>
                            <Controller
                                name="contract_no"
                                control={control}
                                rules={{ required: queueStatusWatch==='3' }}
                                render={({ field }) => <Input placeholder="สัญญาเลขที่" maxLength={50} {...field} />}
                            />
                        </FormControl>
                    </HStack>
                    <HStack w="full" spacing={2}>
                        <FormControl isRequired={queueStatusWatch==='3'}>
                            <FormLabel>จำนวนอายุสัญญา(ปี)</FormLabel>
                            <Controller
                                name="contract_age"
                                control={control}
                                rules={{ required: queueStatusWatch==='3' }}
                                render={({ field }) => <Input placeholder="อายุสัญญา" type="number" min={1} max={4} defaultValue={ageContract} {...field} />}
                            />
                        </FormControl>
                        <FormControl isRequired={queueStatusWatch==='3'}>
                            <FormLabel>เลขที่ห้อง</FormLabel>
                            <Controller
                                name="room_no"
                                control={control}
                                rules={{ required: queueStatusWatch==='3' }}
                                render={({ field }) => <Input placeholder="เลขที่ห้อง" maxLength={50} {...field} />}
                            />
                        </FormControl>
                    </HStack>
                    <HStack w="full" spacing={2}>
                        <FormControl isRequired={queueStatusWatch==='3'}>
                            <FormLabel>วันที่เข้าอยู่</FormLabel>
                            <InputDatePicker control={control} name="contract_start_date" showTimeInput={false} required={queueStatusWatch==='3'}/>
                        </FormControl>
                        <FormControl isRequired={queueStatusWatch==='3'}>
                            <FormLabel>วันที่สิ้นสุดสัญญา</FormLabel>
                            <InputDatePicker control={control} name="contract_end_date" showTimeInput={false} required={queueStatusWatch==='3'} />
                        </FormControl>
                    </HStack>
                </SectionForm>
                <HStack w="full" justify="center">
                    <Button leftIcon={<BsBoxArrowInDown />} colorScheme="blue" type="submit">
                        บันทึกข้อมูล
                    </Button>
                    <Button leftIcon={<BsX />} colorScheme="red" onClick={close}>
                        ยกเลิก
                    </Button>
                </HStack>
            </form>
        </Flex>
    )
}

export default FooterQueueAdmin
